const steps = document.querySelector('.wp-block-transmission-scrollable-timeline');
let allSteps = document.querySelectorAll('.wp-block-transmission-timeline-screen');
const timelineNav = document.querySelector('.nav__track');
allSteps.forEach(function (step) {
	var dataInfo = step.dataset.info;
	var stepLink = document.createElement('button');
	stepLink.innerHTML = dataInfo;
	stepLink.dataset.link = dataInfo;
	stepLink.classList.add('nav__link');
	timelineNav.append(stepLink);
	let firstnav = document.querySelector('.nav__track button:first-child');
	firstnav.classList.add('active');
	let allNavLinks = document.querySelectorAll('.nav__track button');
	allNavLinks.forEach(function (link) {
		link.addEventListener('click', function (e){
			e.preventDefault();
			var activeStep = e.target.dataset.link;
			let currentActive = document.querySelector('.wp-block-transmission-timeline-screen.active');
			let currentNavActive = document.querySelector('.nav__link.active');
			let newActive = document.querySelector('[data-info="'+activeStep+'"]');
			currentActive.classList.remove('active');
			newActive.classList.add('active');
			if(currentNavActive){
				currentNavActive.classList.remove('active');
			}
			e.target.classList.add('active');
		});
	});
});
let firststep = allSteps[0];
firststep.classList.add('active');
